import { useEffect, useState } from "react";

const read = (key, initial) => {
  try {
    const v = localStorage.getItem(key);
    return v === null ? initial : JSON.parse(v);
  } catch {
    return initial;
  }
};

// useState that remembers its value in localStorage under `key` until the user changes it.
export function usePersistedState(key, initial) {
  const [state, setState] = useState(() => read(key, initial));
  const [cur, setCur] = useState(key);
  if (cur !== key) {
    setCur(key);
    setState(read(key, initial));
  }
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(state)); } catch { /* storage full or disabled */ }
  }, [key, state]);
  return [state, setState];
}
